import { SET_ALERT, REMOVE_ALERT } from "../constants/alert";
// const testMsg = {msg: "test"};
const initialState: any[] = [];

const alertReducer = (state = initialState, action: any) => {
  const { type, payload } = action;
  switch (type) {
    case SET_ALERT:
      return [...state, payload];
    case REMOVE_ALERT:
      return state.filter((alert) => alert.id !== payload);
    default:
      return state;
  }
};

export default alertReducer;
